import actions from "./actions";

const initialState = {
  detail: {},
  loading: false,
  error: false,
};

export default function healthCheckReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
